export default __webpack_public_path__ + "static/media/add-card.b18c7df6.svg";